import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, Button, ButtonBase, Collapse, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { listIconMUI } from "../../helper/icon";
import { getParentMenu } from "../../helper/menu";
import { getUserSession } from "../../helper/user";
import { getListMenuConfig } from "../../modules/UAA/service/menuConfigService";
import { setCurrentMenuApp } from "../../redux/bizzAppReducer";
import { appNavigationConfig } from "../../routes/appNavigationConfig";
import { PRIMARY } from "../../theme/colors";
import useCurrenPath from "./useCurrenPath";
import {
  getMenuItemsByRoles,
  menus,
} from "modules/Channel/configs/navigationConfig";
import { LOCAL_STORAGE, getDataSession } from "helper/session";
import { KEY_ROLE_BIZZ_UAA } from "modules/Channel/configs/constant";
import { getApiByProduct } from "modules/UAA/service/permissionConfigService";
import { setListMenu } from "redux/userReducer";
import {
  KEY_LIST_ACTIVE_ROLE,
  KEY_LIST_ROLE_BIZZ_UAA,
} from "modules/UAA/configs/constant";
import _ from "lodash";

const MenuGroup = (props) => {
  const {
    isChecked,
    item,
    location,
    indexNumber,
    isSystemAdmin,
    listPermission,
    setSubMenu,
  } = props;

  const [open, setOpen] = useState(false);

  const { currentRoute } = useCurrenPath();

  const { t, i18n } = useTranslation("common");

  const currentLanguage = i18n.language;

  const groupMenuChecked = (item) => {
    return item?.children?.some(
      (item) => item.path === currentRoute?.path || groupMenuChecked(item)
    );
  };

  const isGroupMenuChecked = groupMenuChecked(item);

  function renderMenuItem(menu) {
    return (
      <>
        {menu?.map((item, index) => {
          const isChecked = location?.pathname.startsWith(item.path);
          const isHavePermision =
            listPermission?.length > 0
              ? listPermission.some((v) => v.id === item.apiId)
              : false;
          if (isHavePermision || isSystemAdmin) {
            return (
              <MenuGroup
                item={item}
                isChecked={isChecked}
                location={location}
                key={index}
                indexNumber={indexNumber + 1}
                isSystemAdmin={isSystemAdmin}
                listPermission={listPermission}
              />
            );
          }
          return null;
        })}
      </>
    );
  }

  if (item.type === "item" || !item?.type) {
    return (
      //style={{ padding: "0px 4px" }}
      <Box>
        <Link
          to={item.url ?? item.path}
          style={{
            textDecoration: "none",
            width: "100%",
          }}
        >
          <Button
            color="primary"
            style={{
              color: isChecked ? "white" : "black",
              padding: 0,
              height: 40,
              width: "100%",
              borderRadius: "0px 20px 20px 0px",
            }}
            variant={isChecked ? "contained" : undefined}
            disableElevation
          >
            <Box
              height={40}
              alignItems="center"
              justifyContent="start"
              paddingRight={"32px"}
              paddingLeft={"16px"}
              style={{
                display: "flex",
                flexDirection: "row",
                flex: 1,
                justifyContent: "space-between",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                  alignItems: "center",
                }}
              >
                {indexNumber > 0 && item?.icon && (
                  <div style={{ marginRight: 8 }}>
                    {
                      listIconMUI({
                        style: { width: 20, height: 20 },
                      }).find((v) => v.name === item?.icon)?.icon
                    }
                  </div>
                )}
                <Typography variant="menuBody" textAlign="initial">
                  {item?.multiLang?.[`${currentLanguage}`]
                    ? item?.multiLang?.[`${currentLanguage}`]
                    : t(item?.name)}
                </Typography>
              </Box>
            </Box>
          </Button>
        </Link>
      </Box>
    );
  }
  if (item.type === "group") {
    return (
      //style={{ padding: "0px 8px" }}
      <Box>
        <Button
          color="primary"
          style={{
            color: isChecked ? "white" : "black",
            padding: 0,
            height: 40,
            width: "100%",
            borderRadius: "0px 20px 20px 0px",
            backgroundColor: isGroupMenuChecked ? "#e0e0e0" : undefined,
          }}
          variant={isChecked ? "contained" : undefined}
          onClick={() => setSubMenu(item)}
          disableElevation
        >
          <Box
            height={40}
            alignItems="center"
            justifyContent="start"
            paddingRight={"12px"}
            paddingLeft={"16px"}
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
              justifyContent: "space-between",
            }}
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                flex: 1,
                alignItems: "center",
              }}
            >
              {indexNumber > 0 && (
                <Box className="">
                  {item?.icon && (
                    <div style={{ marginRight: 8 }}>
                      {
                        listIconMUI({
                          style: { width: 20, height: 20 },
                        }).find((v) => v.name === item?.icon)?.icon
                      }
                    </div>
                  )}
                </Box>
              )}
              <Typography variant="menuBody" textAlign="initial">
                {item?.multiLang?.[`${currentLanguage}`]
                  ? item?.multiLang?.[`${currentLanguage}`]
                  : t(item?.name)}
              </Typography>
            </Box>

            {item.type === "group" && (
              <KeyboardArrowRightIcon
                fontSize="small"
                style={{ transform: open ? "rotate(90deg)" : undefined }}
              />
            )}
          </Box>
        </Button>
      </Box>
    );
  }
  return (
    //className="px-5"
    <Box>
      <Button
        color="primary"
        style={{
          color: isChecked ? "white" : "black",
          padding: 0,
          height: 40,
          width: "100%",
          borderRadius: "0px 20px 20px 0px",
          backgroundColor: isGroupMenuChecked ? "#e0e0e0" : undefined,
        }}
        onClick={() => setOpen(!open)}
        variant={isChecked ? "contained" : undefined}
        disableElevation
      >
        <Box
          height={40}
          alignItems="center"
          justifyContent="start"
          paddingRight={"12px"}
          paddingLeft={"16px"}
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            justifyContent: "space-between",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
              alignItems: "center",
            }}
          >
            {!indexNumber && item?.icon && (
              <div style={{ marginRight: 8 }}>
                {
                  listIconMUI({ style: { width: 20, height: 20 } }).find(
                    (v) => v.name === item?.icon
                  )?.icon
                }
              </div>
            )}
            <Typography variant="menuBody" textAlign="initial">
              {item?.multiLang?.[`${currentLanguage}`]
                ? item?.multiLang?.[`${currentLanguage}`]
                : t(item?.name)}
            </Typography>
          </Box>
          <KeyboardArrowRightIcon
            fontSize="small"
            style={{ transform: open ? "rotate(90deg)" : undefined }}
          />
        </Box>
      </Button>
      {item.children && (
        <Collapse in={open}>
          <Box style={{ paddingLeft: indexNumber >= 0 ? 10 : 0 }}>
            {renderMenuItem(item.children)}
          </Box>
        </Collapse>
      )}
    </Box>
  );
};

export const useMenuRoute = () => {
  const listPermission = useSelector((state) => state.userData.listMenu);
  const { currentBizzApp } = useSelector((state) => state.bizzApps);
  const dispatch = useDispatch();
  const location = useLocation();
  const userInfo = getUserSession();
  const listRoleActive = getDataSession(LOCAL_STORAGE, KEY_LIST_ACTIVE_ROLE);
  const currentRoleCurrent = getDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA);

  const [currentMenu, setCurrentMenu] = useState();
  const [subMenu, setSubMenu] = useState();

  const handleGetListApi = async () => {
    const _roleActive =
      listRoleActive?.roles?.length <= 1 || !currentRoleCurrent
        ? listRoleActive?.roles[0]
        : listRoleActive?.roles?.filter(
            (item) =>
              item.alias.toUpperCase() ===
              currentRoleCurrent?.code.replace(/_/g, "").toUpperCase()
          )?.[0];
    if (listPermission?.length <= 0) {
      const listApi = await getApiByProduct({
        page: 0,
        size: 2000,
        roleId: _roleActive.id,
      });
      const listMenuPermission = listApi.data?.data?.content.filter(
        (ele) => ele.viewType === "MENU"
      );
      !_.isEmpty(listMenuPermission) &&
        dispatch(setListMenu(listMenuPermission ?? null));
    }
  };

  useEffect(() => {
    handleGetListApi();
  }, [listPermission]);

  const isSystemAdmin = userInfo?.roles?.some(
    (item) => item.alias === "SYSTEM_ADMIN"
  );

  const customNavigator = useMemo(() => {
    return appNavigationConfig.map((item) => {
      return {
        ...item,
        children: item.children?.map((child) => {
          return {
            ...child,
            type: child?.type === "group" ? "collapse" : child?.type,
          };
        }),
      };
    });
  }, []);

  const handleChangeMenuRouteType = (menu) => {
    return menu?.map((item) => {
      return {
        ...item,
        path: item.url,
        children: handleChangeMenuRouteType(item?.children) ?? undefined,
      };
    });
  };

  const roleCurrentStore = getDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA);

  const getCurentMenu = async (id) => {
    const res = await getListMenuConfig({ productId: id });
    const totalValue = res?.data?.data?.content ?? null;
    if (totalValue?.length > 0) {
      dispatch(
        setCurrentMenuApp(
          handleChangeMenuRouteType(totalValue[0]?.config?.config ?? [])
        )
      );
      const listMenu = totalValue?.find(
        (item) => item?.platform.toUpperCase() === "WEB"
      );
      setCurrentMenu(listMenu?.config?.config ?? []);
      setSubMenu();
    } else {
      if (currentBizzApp) {
        let chosenBizzAppMenu = customNavigator.find(
          (v) =>
            v.bizzApp.toUpperCase() === currentBizzApp?.alias?.toUpperCase()
        );
        // console.log("apppp", chosenBizzAppMenu);
        if (chosenBizzAppMenu?.bizzApp === "CHANNEL") {
          chosenBizzAppMenu = getMenuItemsByRoles(
            { key: "", label: "" },
            menus,
            roleCurrentStore
          );
        }

        dispatch(setCurrentMenuApp(chosenBizzAppMenu?.children ?? []));
        setCurrentMenu(chosenBizzAppMenu?.children ?? []);
        setSubMenu();
      }
    }
  };

  const handleBackToMenu = () => {
    const parentMenu = getParentMenu(subMenu, {
      id: -1,
      children: currentMenu ?? [],
    });
    if (parentMenu?.id === -1) {
      setSubMenu();
    } else setSubMenu(parentMenu);
  };
  const renderMenuRoutes = () => {
    const totalCurrentMenu = subMenu?.children || currentMenu;
    return (
      <Box flex flexDirection={"column"} style={{ width: "100%" }}>
        {subMenu && (
          <ButtonBase
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: 12,
            }}
            onClick={() => handleBackToMenu()}
          >
            <ArrowBackIcon
              style={{ color: PRIMARY, marginRight: 8, width: 20, height: 20 }}
            />
            <Typography color="primary">{subMenu?.name}</Typography>
          </ButtonBase>
        )}
        {totalCurrentMenu?.map((item, index) => {
          const isChecked = location?.pathname.startsWith(item.path);
          const isHavePermision =
            listPermission?.length > 0
              ? listPermission.some((v) => v.id === item.apiId)
              : false;

          if (isHavePermision || isSystemAdmin) {
            return (
              <MenuGroup
                key={index}
                item={item}
                isChecked={isChecked}
                location={location}
                listPermission={listPermission}
                isSystemAdmin={isSystemAdmin}
                indexNumber={0}
              />
            );
          }
          return null;
        })}
      </Box>
    );
  };

  useEffect(() => {
    if (currentBizzApp?.id) {
      getCurentMenu(currentBizzApp?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBizzApp]);

  return { renderMenuRoutes };
};
